import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  template: `
    <div class="input-group mb-3" style="margin-top:15px;">

      <input [ngClass]="inputClass"
             required="true"
             min="0"
             #rate
             class="form-control short-input"
             type="number"
             step="0.01"
             [name]="cell.getId()"
             [placeholder]="0.01"
             [disabled]="!cell.isEditable()"
             (click)="onClick.emit($event)"
             (keyup)="updateValue()"
             (keydown.enter)="onEdited.emit($event)"
             (keydown.esc)="onStopEditing.emit()"
             style="width: 72px;"
      />
        <div class="input-group-append" style="">
        <span class="input-group-text arial bold centered-text"
              style="height:35px;
                width:34px;
                font-size: 20px;
                padding-left:8px;
                padding-top:7px;">
          %
        </span>
        </div>
    </div>`,
})
export class CustomInterestRateEditorComponent extends DefaultEditor implements AfterViewInit {

  @ViewChild('rate', { static: false }) rate: ElementRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    if (this.cell.newValue !== '') {
      this.rate.nativeElement.value = this.cell.newValue;
    }
  }

  updateValue() {
    this.cell.newValue = this.rate.nativeElement.value;
  }

}
